<template lang="pug">
.error(v-if="!checkRestrictions('ex:shop')")
    Error(:message="null" :code="403")
PaginatedItemsWrapper(
    v-else-if="activeCms"
    scope="ex"
    type="shop_payment_method"
    :items-paginated="itemsPaginated"
    router-path="payment-method-form"
    :loading="loading"
    :show-add-button="checkRestrictions('settings', 'update')"
    v-on:updateLoading="updateLoading"
    v-on:fetchItems="fetchItemsMethod"
    v-on:defineActiveColumns="defineActiveColumns"
    v-on:defineFilterVisibility="defineFilterVisibility"
    v-on:defineItemsPerPage="defineItemsPerPage"
    v-on:defineCurrentPage="defineCurrentPage"
    v-on:defineFilterValue="defineFilterValue"
    v-on:defineSort="defineSort"
)
    template(v-slot:active="{ item }")
        el-switch(
            :value="item.active"
            :disabled="togglingActiveIds.includes(item.id) || !checkRestrictions('settings', 'update')"
            @click.native.stop
            @change="value => toggleActive(item, value)"
        )
</template>

<i18n>
{
    "de": {
        "An error occurred!": "Es ist ein Fehler aufgetreten!",
        "Payment method could not be saved.": "Zahlungsart konnte nicht gespeichert werden."
    }
}
</i18n>

<script>
import { checkRestrictions } from '@/helpers'
import { useSetupStore, useShopPaymentStore } from '@/stores'

import Error from '@/components/Error';
import PaginatedItemsWrapper from '@/components/PaginatedItemsWrapper';

export default {
    name: 'PaymentMethodsPaginated',
    data() {
        return {
            togglingActiveIds: []
        }
    },
    components: {
        Error,
        PaginatedItemsWrapper,
    },
    computed: {
        activeCms() {
            return useSetupStore().activeCms;
        },
        paymentStore() {
            return useShopPaymentStore();
        },
        itemsPaginated() {
            return this.paymentStore.itemsPaginated;
        },
        loading() {
            return this.paymentStore.loading;
        },
    },
    methods: {
        fetchItemsMethod() {
            this.paymentStore.fetchPaginatedItems(this.activeCms.shop.id, this.activeCms.id)
                .then(() => this.paymentStore.updateLoading(false))
                .catch(err => { console.log(err) });
        },
        updateLoading(value) {
            this.paymentStore.updateLoading(value);
        },
        defineActiveColumns(columns) {
            this.paymentStore.defineActiveColumns(columns);
        },
        defineFilterVisibility(value) {
            this.paymentStore.defineFilterVisibility(value);
        },
        defineItemsPerPage(perPage) {
            this.paymentStore.defineItemsPerPage(perPage);
        },
        defineCurrentPage(page) {
            this.paymentStore.defineCurrentPage(page);
        },
        defineFilterValue(payload) {
            this.paymentStore.defineFilterValue(payload);
        },
        defineSort(payload) {
            this.paymentStore.defineSorting(payload);
        },
        toggleActive(item, active) {
            const previous = item.active;
            item.active = active;
            this.togglingActiveIds.push(item.id);

            this.paymentStore.updatePaymentMethodActive({ id: item.id, active })
                .catch(err => {
                    item.active = previous;

                    console.error(err);

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Payment method could not be saved.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .finally(() => {
                    this.togglingActiveIds = this.togglingActiveIds.filter(id => id !== item.id);
                });
        },
        checkRestrictions,
    }
};
</script>

<style lang="sass" scoped>
.error
    display: flex
    justify-content: center
    min-height: 200px
</style>
